<template>
  <div>
    <b-card class="md-3" style="min-height: 410px">
      <!-- Titulo de la seccion-->
      <b-row>
        <b-col class="align-left">
          <p style="padding-left: 40px">Configuración del panel web</p>
        </b-col>
      </b-row>

      <div id="formulario-nodos" style="width: 100%">
        <!-- INIT FORMULARIO DE ADICION -->
        <b-form>
          <!-- CONFIGURACION SERVIDOR CORREO-->
          <div class="groupBox mb-3">
            <b-row>
              <div class="col-lg-4 col-md-6 col-sm-6">
                <Input
                  type="text"
                  v-model="smtp_server"
                  id="server"
                  label="Servidor SMTP"
                  invalid="Introduzca un servidor válido"
                  :required="true"
                  icon="fas fa-server"
                />
              </div>

              <div class="col-lg-4 col-md-6 col-sm-6">
                <Input
                  type="text"
                  v-model="smtp_username"
                  id="username"
                  label="Email"
                  invalid="Introduzca un nombre de usuario válido"
                  :required="true"
                  icon="fas fa-user"
                />
              </div>

              <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6">
                <Input
                  type="password"
                  v-model="smtp_password"
                  id="password"
                  label="Contraseña"
                  invalid="Introduzca una contraseña válido"
                  :required="true"
                  icon="fas fa-key"
                />
              </div>

              <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6">
                <Input
                  type="number"
                  v-model="smtp_port"
                  id="puerto"
                  label="Puerto SMTP"
                  title="Introduzca un puerto válido"
                  :min="0"
                  :max="65535"
                  :required="true"
                  icon="far fa-dot-circle"
                />
              </div>

              <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 pt-4 ps-5 mt-3">
                <input
                  class="form-check-input"
                  v-model="smtp_forceTLS"
                  type="checkbox"
                  name="forceTLS"
                />
                <label
                  class="form-check-label"
                  for="forceTLS"
                  @click="smtp_forceTLS = !smtp_forceTLS"
                  ><span class="etiqueta">Usar SMTP SSL/TLS</span></label
                >
              </div>
            </b-row>
          </div>

          <!-- CONFIGURACION SMS APIKEY-->
          <div class="groupBox mb-3">
            <b-row>
              <div class="col-lg-4 col-md-6 col-sm-6">
                <Input
                  type="text"
                  v-model="sms_apikey"
                  id="server"
                  label="API KEY SMS"
                  invalid="Introduzca un servidor válido"
                  :required="false"
                  icon="fas fa-server"
                />
              </div>
            </b-row>
          </div>

          <!-- CONFIGURACION TEST labo-->
          <div class="groupBox mb-3">
            <b-row>
              <div class="col-lg-3 col-md-4 col-sm-6">
                <Input
                  type="text"
                  v-model="smtp_test"
                  id="smtpTest"
                  label="Correo de prueba"
                  invalid="Introduzca un email válido"
                  icon="fas fa-server"
                />
              </div>

              <div class="col-lg-3 col-md-6 col-sm-6 pt-3">
                <b-button
                  class="mt-4"
                  style="max-width: 300px"
                  type="submit"
                  name="sendEmailTest"
                  id="sendEmailTest"
                  variant="secondary"
                  size="sm"
                  @click="sendEmailTest"
                >
                  <i class="fas fa-paper-plane"></i>
                  <span
                    class="text-uppercase"
                    style="font-size: 12px; font-weight: bold; margin-left: 5px"
                    >Enviar email de prueba</span
                  >
                </b-button>
              </div>

              <div class="col-lg-3 col-md-4 col-sm-6">
                <Input
                  type="text"
                  v-model="sms_test"
                  id="smsTest"
                  placeholder="+34...."
                  label="SMS de prueba"
                  invalid="Introduzca un telefono válido"
                  icon="fas fa-server"
                />
              </div>

              <div class="col-lg-3 col-md-6 col-sm-6 pt-3">
                <b-button
                  class="mt-4"
                  type="submit"
                  name="sendSMSTest"
                  id="sendSMSTest"
                  variant="secondary"
                  size="sm"
                  @click="sendSMSTest"
                >
                  <i class="fas fa-sms"></i>
                  <span
                    class="text-uppercase"
                    style="font-size: 12px; font-weight: bold; margin-left: 5px"
                    >Enviar sms de prueba</span
                  >
                </b-button>
              </div>
            </b-row>
          </div>

          <!-- CONFIGURACION SECCIONES ACTIVAS -->
          <div class="groupBox">
            <!-- Fila 1 -->
            <b-row style="padding: 30px">
              <b-col>
                <input
                  class="form-check-input"
                  v-model="advancedAnalysisFlag"
                  type="checkbox"
                  name="advancedAnalysisFlag"
                />
                <label
                  class="form-check-label"
                  for="advancedAnalysisFlag"
                  @click="advancedAnalysisFlag = !advancedAnalysisFlag"
                  ><span class="etiqueta"
                    >Activar sección "Análisis avanzado"</span
                  >
                  <br /><small class="miniEtiqueta"
                    >(Con esta opción se activa el análisis avanzado para el
                    cálculo de salud estructural. Si no está seguro, deje la
                    opción desmarcada.)</small
                  ></label
                >
              </b-col>

              <b-col cols="2"> </b-col>

              <b-col>
                <!-- Sección roles -->
                <input
                  class="form-check-input"
                  v-model="rolesFlag"
                  type="checkbox"
                  name="rolesFlag"
                />
                <label
                  class="form-check-label"
                  for="rolesFlag"
                  @click="rolesFlag = !rolesFlag"
                  ><span class="etiqueta">Activar sección "Roles"</span>
                  <br /><small class="miniEtiqueta"
                    >(Con esta opción se activa la sección de roles que sólo
                    está integrada en la v2 de "Smart Iot Dashboard".)</small
                  ></label
                >
              </b-col>
            </b-row>

            <!-- Fila 2 -->
            <b-row style="padding: 30px">
              <b-col>
                <input
                  class="form-check-input"
                  v-model="seismicFlag"
                  type="checkbox"
                  name="seismicFlag"
                />
                <label
                  class="form-check-label"
                  for="seismicFlag"
                  @click="seismicFlag = !seismicFlag"
                  ><span class="etiqueta">Activar toma de datos "Sismos"</span>
                  <br /><small class="miniEtiqueta"
                    >(Con esta opción se activa la toma de datos de sismos. Si
                    no está seguro, deje la opción desmarcada.)</small
                  ></label
                >
              </b-col>

              <b-col cols="2"> </b-col>

              <b-col>
                <!-- Sección roles -->
                <input
                  class="form-check-input"
                  v-model="riverFlag"
                  type="checkbox"
                  name="riverFlag"
                />
                <label
                  class="form-check-label"
                  for="riverFlag"
                  @click="riverFlag = !riverFlag"
                  ><span class="etiqueta">Activar toma de datos "Ríos"</span>
                  <br /><small class="miniEtiqueta"
                    >(Con esta opción se activa la toma de datos de ríos. Si no
                    está seguro, deje la opción desmarcada.)</small
                  ></label
                >
              </b-col>
            </b-row>

            <!-- Fila 2.1 -->
            <b-row style="padding: 30px">
              <b-col>
                <input
                  class="form-check-input"
                  v-model="notificationFlag"
                  type="checkbox"
                  name="notificationFlag"
                />
                <label
                  class="form-check-label"
                  for="notificationFlag"
                  @click="notificationFlag = !notificationFlag"
                  ><span class="etiqueta">Activar sección de "Alertas"</span>
                  <br /><small class="miniEtiqueta"
                    >(Con esta opción se activa el acceso a la sección de
                    alertas. Podrá acceder a ella puslando en la campanita
                    superior.)</small
                  ></label
                >
              </b-col>
              <b-col cols="2"> </b-col>
              <b-col>
                <!-- Sección roles -->
                <input
                  class="form-check-input"
                  v-model="configNodesFlag"
                  type="checkbox"
                  name="configNodesFlag"
                />
                <label
                  class="form-check-label"
                  for="configNodesFlag"
                  @click="configNodesFlag = !configNodesFlag"
                  ><span class="etiqueta">Activar sección "Config. de Nodos"</span>
                  <br /><small class="miniEtiqueta"
                    >(Con esta opción se activa la sección de configuracion de nodos. Específica del proyecto Atlantic Copper.)</small
                  ></label
                >
              </b-col>
            </b-row>

            <!-- Fila 2.2 -->
            <b-row style="padding: 30px">
              <b-col>
                <input
                  class="form-check-input"
                  v-model="configNodesRecuFlag"
                  type="checkbox"
                  name="configNodesRecuFlag"
                />
                <label
                  class="form-check-label"
                  for="configNodesRecuFlag"
                  @click="configNodesRecuFlag = !configNodesRecuFlag"
                  ><span class="etiqueta">Activar envío de configuración forzada recurrente</span>
                  <br /><small class="miniEtiqueta"
                    >(Con esta opción se activa el envío programático de la sección "Config. Nodos" a los nodos .)</small
                  ></label
                >
              </b-col>
              <b-col cols="2"> </b-col>
              <b-col>
                <!-- EMPTY FOR NOW -->
                <!-- EMPTY FOR NOW -->
              </b-col>
            </b-row>

          </div>

          <!-- Fila 3 -->
          <b-row style="margin-top: 20px">
            <b-col align="center">
              <b-button
                style="max-width: 300px"
                type="submit"
                name="saveProjectConfig"
                id="saveProjectConfig"
                variant="primary"
                size="sm"
                @click="saveProjectConfig"
              >
                <i class="fas fa-file-import"></i>
                <span
                  class="text-uppercase"
                  style="font-size: 12px; font-weight: bold; margin-left: 5px"
                  >Actualizar configuración del panel</span
                >
              </b-button>
            </b-col>
          </b-row>
        </b-form>
        <!-- END FORMULARIO DE ADICION -->
      </div>

      <!-- Formulario de adicion de nodos -->
    </b-card>
  </div>
</template>

<script>
import PanelConfigService from "@/services/PanelConfigService";
import Input from "@/components/common/form/Input";

export default {
  data() {
    return {
      advancedAnalysisFlag: false,
      rolesFlag: false,
      seismicFlag: false,
      riverFlag: false,
      notificationFlag: false,
      configNodesRecuFlag: false,
      configNodesFlag: false,
      smtp_server: "",
      smtp_username: "",
      smtp_password: "",
      smtp_port: "",
      smtp_forceTLS: false,
      smtp_test: "",
      sms_test: "",
      sms_apikey: "",
    };
  },
  components: {
    Input,
  },
  mounted() {
    this.retrievePanelConfig();
  },
  methods: {
    async saveProjectConfig(e) {
      e.preventDefault();

      let dataToUpdate = {
        advanced_shm_analysis: this.advancedAnalysisFlag,
        roles_flag: this.rolesFlag,
        seismic_flag: this.seismicFlag,
        river_flag: this.riverFlag,
        notification_flag: this.notificationFlag,
        configNodesRecu_flag: this.configNodesRecuFlag,
        configNodes_flag: this.configNodesFlag,
        smtp_server: this.smtp_server,
        smtp_username: this.smtp_username,
        smtp_password: this.smtp_password,
        smtp_port: this.smtp_port,
        smtp_forceTLS: this.smtp_forceTLS,
        sms_apikey: this.sms_apikey,
      };

      await PanelConfigService.updatePanelConfig(dataToUpdate)
        .then((response) => {
          this.$notify({
            group: "notificateDiv",
            type: "success",
            title: "Cambios guardados",
            text: "Se han guardado los cambios en la configuración del panel",
            duration: 3000,
            speed: 1000,
          });
        })
        .catch((err) => {
          console.log("Error actualizando configuración del panel");
          console.log(err);
          this.$notify({
            group: "notificateDiv",
            type: "error",
            title: "Error guardando cambios",
            text: "Ha ocurrido un error guardando los cambios en la configuración del panel",
            duration: 3000,
            speed: 1000,
          });
        });
    },

    async retrievePanelConfig() {
      await PanelConfigService.getPanelConfig()
        .then((panelConfig) => {
          console.log(panelConfig);
          this.advancedAnalysisFlag =
            panelConfig.data.advanced_shm_analysis &&
            panelConfig.data.advanced_shm_analysis === true
              ? true
              : false;

          this.rolesFlag =
            panelConfig.data.roles_flag && panelConfig.data.roles_flag === true
              ? true
              : false;

          this.seismicFlag =
            panelConfig.data.seismic_flag &&
            panelConfig.data.seismic_flag === true
              ? true
              : false;

          this.riverFlag =
            panelConfig.data.river_flag && panelConfig.data.river_flag === true
              ? true
              : false;

          this.notificationFlag =
            panelConfig.data.notification_flag && panelConfig.data.notification_flag === true
              ? true
              : false;     
              
          this.configNodesRecuFlag =
            panelConfig.data.configNodesRecu_flag && panelConfig.data.configNodesRecu_flag === true
              ? true
              : false;                 

          this.configNodesFlag =
            panelConfig.data.configNodes_flag && panelConfig.data.configNodes_flag === true
              ? true
              : false;    

          this.smtp_server =
            panelConfig.data.smtp && panelConfig.data.smtp.server
              ? panelConfig.data.smtp.server
              : "";

          this.smtp_username =
            panelConfig.data.smtp && panelConfig.data.smtp.username
              ? panelConfig.data.smtp.username
              : "";

          this.smtp_password =
            panelConfig.data.smtp && panelConfig.data.smtp.password
              ? panelConfig.data.smtp.password
              : "";

          this.smtp_port =
            panelConfig.data.smtp && panelConfig.data.smtp.port
              ? panelConfig.data.smtp.port
              : "";

          this.smtp_forceTLS =
            panelConfig.data.smtp &&
            panelConfig.data.smtp.forceTLS &&
            panelConfig.data.smtp.forceTLS === true
              ? true
              : false;

          this.sms_apikey =
            panelConfig.data.sms && panelConfig.data.sms.apikey
              ? panelConfig.data.sms.apikey
              : "";
        })
        .catch((err) => {
          console.log("Error recuperando configuración del panel");
          console.log(err);
        });
    },

    async sendEmailTest(e) {
      e.preventDefault();
      let data = {
        smtp_test: this.smtp_test,
      };
      await PanelConfigService.sendEmailTest(data)
        .then((response) => {
          this.$notify({
            group: "notificateDiv",
            type: "success",
            title: "Email de test enviado",
            text: "Compruebe su bandeja de entrada durante los proximos minutos",
            duration: 3000,
            speed: 1000,
          });
        })
        .catch((err) => {
          this.$notify({
            group: "notificateDiv",
            type: "error",
            title: "Error enviando email",
            text: "Ha ocurrido un error mientras se enviaba el email de prueba",
            duration: 3000,
            speed: 1000,
          });
        });
    },

    async sendSMSTest(e) {
      e.preventDefault();
      let data = {
        sms_test: this.sms_test,
      };
      await PanelConfigService.sendSMSTest(data)
        .then((response) => {
          this.$notify({
            group: "notificateDiv",
            type: "success",
            title: "SMS de test enviado",
            text: "Compruebe su movil durante los proximos minutos",
            duration: 3000,
            speed: 1000,
          });
        })
        .catch((err) => {
          this.$notify({
            group: "notificateDiv",
            type: "error",
            title: "Error enviando sms",
            text: "Ha ocurrido un error mientras se enviaba el sms de prueba",
            duration: 3000,
            speed: 1000,
          });
        });
    },
  },
};
</script>


<style scoped>
/* OTHER STYLES*/
/**************/
.groupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 30px;
  margin-left: 30px;
  margin-right: 30px;
}

.innergroupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.form-check-input {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.form-check-label {
  margin-left: 15px;
  cursor: pointer;
}
.form-check-label:hover {
  animation: glow 1s ease-in-out infinite alternate;
}
.etiqueta {
  font-size: 14px;
  font-weight: 400;
}
.miniEtiqueta {
  font-size: 13px;
  font-weight: 300;
}
@-webkit-keyframes glow {
  from {
    text-shadow: 0 0 1px white, 0 0 2px #abc2e4, 0 0 3px #abc2e4,
      0 0 4px #abc2e4, 0 0 5px #abc2e4, 0 0 6px #abc2e4, 0 0 7px #abc2e4;
  }

  to {
    text-shadow: 0 0 1px white, 0 0 3px #9fc8ff, 0 0 4px #9fc8ff,
      0 0 5px #9fc8ff, 0 0 6px #9fc8ff, 0 0 7px #9fc8ff, 0 0 8px #9fc8ff;
  }
}
</style>
